import { Route, Routes } from 'react-router-dom';

import { ConnectWiseRoutes } from './connect-wise/connect-wise.routes';
import { ServiceNowRoutes } from './service-now/service-now.routes';

export const ItsmIntegrationsRoutes = () => {
  return (
    <Routes>
      <Route path="connect-wise/*" element={<ConnectWiseRoutes />} />
      <Route path="service-now/*" element={<ServiceNowRoutes />} />
    </Routes>
  );
};
